export default {
  '401': '身份验证已失效',
  '403': '操作无权限',
  '404': '资源不存在',
  'default': '未知错误'
}
